export default __webpack_public_path__ + "static/media/knowMoreCustomer1.6cd49bcc.png";